import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pagenofound',
  templateUrl: './pagenofound.component.html',
  styleUrls: ['./pagenofound.component.scss']
})
export class PagenofoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
